import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Select2Multiple from 'v-select2-multiple-component';
import {
  required,
  maxLength,
  minValue
} from "vuelidate/lib/validators";
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import CONFIG from "@/assets/js/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import upLoad from '@/assets/img/upload_photo3.jpg';
import store from '@/store';
import axios from 'axios';
import Vue from 'vue';

export default {
  name: "paymentEdit",
  components: {
    MainLayout,
    flatPickr,
    Select2Multiple,
    Loading
  },

  data() {
    return {
      config: CONFIG,
      imageLargeMsg: CONFIG.IMAGE_TOO_LARGE,
      inputData: {
        class_id: '',
        student_id: '',
        guardian1_name: '',
        item_id: '',
        discount_type: null,
        discount_amount: null,
        discount_note: '',
        gross_total_amt: 0,
        net_total_amt: 0,
      },
      paymentData: {
        class_id: '',
        student_id: '',
        guardian1_name: '',
        is_discount: 0,
        discount_type: null,
        discount_amount: null,
        gross_total_amt: 0,
        net_total_amt: 0,
        payment_method_id: '',
        payment_date: '',
        enrollment_date: '',
        status: '',
        receiver: '',
        remark: '',
        payment_screenshot: '',
        image_remove: false,
      },
      paymentDetail: [],
      editData: [],
      loginId: store.state.user.id,
      ssImage: '',
      addItem: false,
      campusId: store.state.user.campus_id,
      paymentMethodArr: null,
      isLoading: false,
      upLoad,
      disabled: false,
      noDataMsg: CONFIG.NO_DATA_EXIST,
      submitted: false,
      studentId: null,
      imgRemove: false,
      guardian1_name: '',
      student_name: '',
      visible: false,
      itemArr: [],
      itemAmtArr: [],
      class_name: '',
      discountPercent: '',
      discountFixAmount: '',
      discountError: '',
      paymentDiscountError: '',
      discountPercentageAmount: 0,
    };
  },

  validations() {
    const isValidDiscount = (value) => {
      const netTotalAmt = this.inputData?.gross_total_amt || 0;
      return (
        value === null ||
        value === undefined ||
        (value >= 0 && value <= netTotalAmt)
      );
    };

    const isValidPaymentDiscount = (value) => {
      const netTotalAmt = this.netTotalSum || 0;
      return (
        value === null ||
        value === undefined ||
        (value >= 0 && value <= netTotalAmt)
      );
    };

    const isInteger = (value) => {
      return value === null || value === undefined || Number.isInteger(value);
    };

    const requiredIfStatusIs1 = (value) => {
      return !(this.paymentData.status == CONFIG.PAYMENT_STATUS.STATUS_APPROVED && (value === null || value === ''));
    };

    return {
      inputData: {
        class_id: {
          required,
        },
        student_id: {
          required,
        },
          item_id: {
          required
        },
        gross_total_amt: {
          required
        },
        net_total_amt: {
          required,
        },
        discount_amount: {
          isValidDiscount,
          isInteger,
        },
        discount_note: {
          maxLength: maxLength(1000)
        },
      },
      paymentData: {
        class_id: {
          required,
        },
        student_id: {
          required,
        },
        gross_total_amt: {
          required
        },
        discount_amount: {
          isValidPaymentDiscount,
          isInteger,
        },
        net_total_amt: {
          required,
          minValue: minValue(0)
        },
        payment_method_id: {
          requiredIfStatusIs1
        },
        receiver: {
          requiredIfStatusIs1,
          maxLength: maxLength(100)
        },
        payment_date: {
          requiredIfStatusIs1
        },
        status: {
          required
        },
        remark: {
          maxLength: maxLength(1000)
        },
      }
    };
  },

  methods: {
    resetInputData() {
      const preservedValues = {
        class_id: this.inputData.class_id,
        student_id: this.inputData.student_id,
        guardian1_name: this.inputData.guardian1_name,
      };
      this.inputData = {
        ...preservedValues,
        item_id: '',
        discount_type: null,
        discount_amount: null,
        discount_note: "",
        gross_total_amt: 0,
        net_total_amt: 0,
      };
    },

    getItem() {
      axios.get('item/getItemForPayment')
        .then(res => {
          this.itemArr = res.data.data;
          this.itemAmtArr = res.data.data;
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    getAmt(item_id) {
      var selectedItem = this.itemAmtArr.find(item => item.id == item_id);
      this.inputData.net_total_amt = selectedItem.p_item_amount;
      this.inputData.gross_total_amt = selectedItem.p_item_amount;
    },

    getPaymentMethod() {
      axios.get('getPaymentMethod')
        .then(res => {
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'Select Payment Method'
          }];
          this.paymentMethodArr = $defaultSelectOption.concat(res.data);
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    calculateNetTotal() {
      let discountAmount = this.inputData.discount_amount || 0;
      this.discountError = "";
      if (discountAmount < 0) {
          this.discountError = "Discount amount cannot be negative.";
          discountAmount = 0;
      }
      if (this.inputData.discount_type == 1) {
          if (this.inputData.gross_total_amt != 0 && discountAmount > this.inputData.gross_total_amt) {
              this.discountError = "Discount amount cannot exceed net total.";
              discountAmount = 0;
          }
          this.inputData.net_total_amt = this.inputData.gross_total_amt - discountAmount;
      } else if (this.inputData.discount_type == 2) {
          if (discountAmount > 100) {
            this.inputData.discount_amount = 100; // Cap discount to 100%
          }
          const discount = (this.inputData.gross_total_amt * discountAmount) / 100;
          this.inputData.net_total_amt = this.inputData.gross_total_amt - discount;
      }
      if (this.inputData.net_total_amt < 0) this.inputData.net_total_amt = 0; // Ensure net total is not negative
    },

    onItemChange() {
      this.getAmt(this.inputData.item_id);
      this.calculateNetTotal();
    },

    removeImg() {
      this.ssImage = '';
      document.getElementById('image').value = '';
      if (this.paymentData.payment_screenshot  != null) {
        this.imgRemove = true;
        this.paymentData.payment_screenshot  = '';
    }
    },

    getDetail() {
      var request = {
        params: {
          campus_id: this.campusId,
          class_id: this.$route.params.classId
        }
      }
      axios.get(`payment/editDetail/${this.$route.params.invoiceId}`, request)
        .then(res => {
          if (!res.data) {
            this.studentId = null;
            this.isLoading = false;
            return;
          }
          this.inputData.class_id = res.data.class_id;
          this.inputData.student_id = res.data.student_id;
          this.inputData.guardian1_name = res.data.guardian1_name;
          this.paymentData = res.data.payment_data;
          this.paymentDetail = res.data.payment_details;
          this.studentId = res.data.student_id;
          this.student_name = res.data.student_name;
          this.guardian1_name = res.data.guardian1_name;
          this.class_name = res.data.class_name;
          if(this.paymentData.discount_type == 1) {
            this.discountFixAmount = parseInt(this.paymentData.discount_amount);
          } else if (this.paymentData.discount_type == 2) {
            this.discountPercent = parseInt(this.paymentData.discount_amount);
          }
          this.isLoading = false;
        })
        .catch(error => {
          this.studentId = null;
          if (error.response) {
            if (error.response.status == 401) {
              this.$store.commit('logout');
              window.location.replace('login');
            }
          }
          this.isLoading = false;
        })
    },

    imgUpload(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return null;
      } else {
        if (e.target.files[0].type.includes("image/")) {
          if (e.target.files[0].type == "image/gif") {
            this.$notification.error("File not supported!", {
              timer: 3,
              position: "bottomCenter",
            });
            return null;
          }
          let reader = new FileReader();
          reader.onload = (e) => {
            if (e.target.result.length > 5242880) {
              this.$notification.error(this.imageLargeMsg, {
                timer: 3,
                position: "bottomCenter",
              });
            } else {
              this.ssImage = e.target.result;
              document.getElementById('image').value = '';
            }
          }
          reader.readAsDataURL(files[0]);
          this.inputData.imgShow = true;
        } else {
          this.$notification.error("File not supported!", {
            timer: 3,
            position: "bottomCenter",
          });
          return null;
        }
      }
    },

    addEditData() {
      this.paymentDetail.push(Vue.util.extend({}, this.editData));
      this.editData = [];
    },

    addData() {
      if (this.editData.item_id) {
        this.paymentDetail.push(Vue.util.extend({}, this.inputData));
      }
    },

    reset() {
      this.addItem = false;
      if (this.editData.item_id != null) {
        this.addEditData();
      }
      this.resetInputData();
    },

    cloneForm() {
      this.editData = [];
      this.addItem = true;
      if (this.$v.inputData.$invalid || this.discountError != "") {
        return;
      }
      if (this.paymentDetail.length < 20) {
        const exists = this.paymentDetail.some(detail => detail.item_id == this.inputData.item_id);
  
        if (!exists) {
          this.paymentDetail.push(Vue.util.extend({}, this.inputData));
        } else {
          this.$notification.error("Payment Item Is Already Exists.", {
            timer: 3,
            position: "bottomCenter"
          });
        }
        this.resetInputData();
      } else {
        alert('Payment can be created at most 20.');
      }
      this.addItem = false;
    },

    editClone(index) {
      this.addData();
      this.getEditData(this.paymentDetail[index]);
      this.inputData = {
        ...this.paymentDetail[index],
        class_id: this.inputData.class_id,
        student_id: this.inputData.student_id
      };
      Vue.delete(this.paymentDetail, index);
    },

    getEditData(data) {
      this.editData.class_id = data.class_id;
      this.editData.student_id = data.student_id;
      this.editData.guardian1_name = data.guardian1_name;
      this.editData.item_id = data.item_id;
      this.editData.discount_type = data.discount_type;
      this.editData.discount_amount = data.discount_amount;
      this.editData.discount_note = data.discount_note;
      this.editData.gross_total_amt = data.gross_total_amt;
      this.editData.net_total_amt = data.net_total_amt;
      if (data.id) {
        this.editData.id = data.id;
      }
    },

    removeClone(index) {
      Vue.delete(this.paymentDetail, index);
      if (this.paymentDetail.length == 0) {
        this.discountPercent = '';
        this.discountPercentageAmount = null;
        this.discountFixAmount = '';
      }
    },

    update() {
      if (this.disabled) return;
      this.submitted = true;
      this.disabled = true;
      this.paymentData.gross_total_amt = this.netTotalSum;
      this.paymentData.net_total_amt = this.totalAfterDiscount;
      this.paymentData.payment_screenshot = this.ssImage ? this.ssImage : this.paymentData.payment_screenshot;
      this.paymentData.image_remove = this.imgRemove;
      if (this.paymentData.payment_method_id == 0) {
        this.paymentData.payment_method_id = null;
      }

      if(this.paymentDetail.length == 0) {
        this.$notification.error("Payment Item Is Required.", {
          timer: 3,
          position: "bottomCenter"
        });
        this.disabled = false;
        return;
      }

      if (this.submitted && this.$v.paymentData.$invalid) {
        this.disabled = false;
        return;
      }
      
      axios.post(`payment/update/${this.$route.params.invoiceId}`, {
        paymentData: this.paymentData,
        paymentDetail: this.paymentDetail,
        loginId: store.state.user.id,
      })
        .then(res => {
          if (res.data) {
            this.$notification.success("Payment Updated Successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({
              name: "paymentList"
            });
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          if (error.response.status == 422) {
            const messages = Object.values(error.response.data.errors).flat().join('\n');
            this.$notification.error(messages, {
              timer: 3,
              position: "bottomCenter"
            });
          }
          this.disabled = false;
          this.isLoading = false;
        })
    },

    formatDiscountAmount(amount) {
      return amount ? this.$options.filters.numFormat(amount) : '_';
    },

    checkDiscountType(discount_amount, discount_type) {
      if (discount_amount <= 0) {
        return "_";
      }
      return discount_type == 1 ? 'Fixed' : 'Percentage';
    },
  },

  watch: {
    discountPercent(val) {
      if (val !== '') {
          this.discountFixAmount = '';
      } else {
          this.discountPercentageAmount = 0;
      }
    },
    discountFixAmount(val) {
        if (val !== '') {
            this.discountPercent = '';
        }
    },
    'paymentData.status'(newVal) {
      if (newVal == CONFIG.PAYMENT_STATUS.STATUS_ADMIN_REQUEST) {
        this.paymentData.payment_date = null;
      }
    },
    'inputData.discount_type'() {
      this.inputData.discount_amount = null;
      this.inputData.net_total_amt = this.inputData.gross_total_amt;
      this.discountError = "";
    }
 },

 computed: {
    netTotalSum() {
      return this.paymentDetail.reduce((sum, item) => sum + (parseFloat(item.net_total_amt) || 0), 0);
    },
    totalAfterDiscount() {
      this.paymentDiscountError = '';
      if(this.discountPercent < 0 || this.discountFixAmount <0 ) {
        this.paymentDiscountError = "Discount amount cannot be negative.";
      }

      if (this.discountPercent) {
        if (this.discountPercent > 100) {
          this.discountPercent = 100; // Cap discount to 100%
        }
        this.paymentData.is_discount = 1;
        this.paymentData.discount_type = 2;
        this.paymentData.discount_amount = Number(this.discountPercent);
        this.discountPercentageAmount = this.netTotalSum * this.discountPercent / 100;
        return this.netTotalSum -  this.discountPercentageAmount;
      } else if (this.discountFixAmount) {
        this.paymentData.is_discount = 1;
        this.paymentData.discount_type = 1;
        this.paymentData.discount_amount = Number(this.discountFixAmount);
        return this.netTotalSum - this.discountFixAmount;
      } else {
        this.paymentData.is_discount = 0;
        this.paymentData.discount_type = null;
        this.paymentData.discount_amount = null;
        return this.netTotalSum;
      }
    },
    paymentOptions() {
      return CONFIG.PAYMENT_STATUSES_OPTIONS.filter(opt =>[
          CONFIG.PAYMENT_STATUS.STATUS_APPROVED, 
          CONFIG.PAYMENT_STATUS.STATUS_DECLINED,
          CONFIG.PAYMENT_STATUS.STATUS_ADMIN_REQUEST,
        ].includes(opt.id)
      );
    },
    isApproveStatus() {
      return Number(this.paymentData.status) === this.config.PAYMENT_STATUS.STATUS_APPROVED;
    }
  },

  mounted() {
    this.isLoading = true
    this.getItem();
    this.getDetail();
    this.getPaymentMethod();
  },
};
